// extracted by mini-css-extract-plugin
module.exports = {"FAQ":"FAQ_FAQ__2sZTe"};